import type { PostFormValues } from "@circle-react/components/QuickPostV3/data/types";
import { useQuickPostV3ModalStore } from "@circle-react/components/QuickPostV3/store";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";

export const FormStateBridge = () => {
  const {
    formState: { isDirty },
  } = useFormContext<PostFormValues>();
  const setIsDirty = useQuickPostV3ModalStore(state => state.setIsDirty);

  useEffect(() => {
    setIsDirty(isDirty);
  }, [isDirty, setIsDirty]);

  return null;
};
